import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { animateScroll as Scroll } from 'react-scroll';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Description,
  Content,
  Block,
  Button,
} from 'components/landing/components';

import './Careers.css';

const dumbCareers = dumbBem('l-careers');
const HeaderButtonWrp = tx([{ element: 'header-buttons-wrapper' }, dumbCareers])('div');

const ADDITIONAL_OFFSET = 70;

class Header extends Component {
  handleScroll(offsetTop, duration) {
    const settings = {};
    if (duration) settings.duration = duration;

    Scroll.scrollTo(offsetTop - ADDITIONAL_OFFSET, settings);
  }

  render() {
    const {
      offersRef,
      perksRef,
      title,
      description,
    } = this.props;

    return (
      <Block modifier="header">
        <Content modifier="header">
          <Title modifier="title" data-testid="title">{title}</Title>
          <Description data-testid="description">{description}</Description>

          <HeaderButtonWrp>
            <Button
              onClick={() => this.handleScroll(offersRef.current.offsetTop)}
              data-testid="jobs"
            >
              JOBS
            </Button>

            <Button
              onClick={() => this.handleScroll(perksRef.current.offsetTop, 500)}
              modifier="reversed-colors"
              data-testid="perks"
            >PERKS
            </Button>
          </HeaderButtonWrp>
        </Content>
      </Block>
    );
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  offersRef: PropTypes.object.isRequired,
  perksRef: PropTypes.object.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/Header.jsx